// import 'react-app-polyfill/ie11';
import React from 'react';
//import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import { createRoot } from 'react-dom/client';
import { PendientesProvider } from './context/PendientesContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <AuthProvider>
        <PendientesProvider>
            <HashRouter>
                <ScrollToTop>
                    <App></App>
                </ScrollToTop>
            </HashRouter>
        </PendientesProvider>
    </AuthProvider>
);